import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { type SafeHtml } from 'kerfjs';
import { Plus } from 'lucide';

/** The primary "+ New…" action: a standalone Kerf brand button (HS2-5RTQ6F). */
export function PrimaryAddControl({ action, label }: { action: string; label: string }): SafeHtml {
  return (
    <Button
      tone="brand"
      emphasis="primary"
      size="default"
      shape="pill"
      action={action}
      icon={<LucideIcon icon={Plus} name="" />}
    >
      {label}
    </Button>
  );
}
